export default {
	generatedSignedUrl: {
		timeFrames: [{
			name          : '30 Minutes',
			valueInSeconds: 1800
		}, {
			name          : '1 Hour',
			valueInSeconds: 3600
		}, {
			name          : '2 Hours',
			valueInSeconds: 7200
		}, {
			name          : '24 Hours',
			valueInSeconds: 86400
		}, {
			name          : '7 days',
			valueInSeconds: 604800
		}, {
			name          : 'Custom time...',
			valueInSeconds: 0
		}]
	},
	distributeBundleService: {
		dragDropHeaders:{
			leftTitle: 'Available Destinations',
			rightTitle: 'Selected Destinations'
		}
	}
};


// WEBPACK FOOTER //
// ./modules/distribution/constants/services.constants.js